import { useEffect, useState } from "react";

import loadingWholeAppLottie from "assets/files/loading-whole-app-lottie.json";
import { ApplicationCode, LanguageID } from "configs";
import { message } from "contexts";
import { useAuth, useDidMountWithoutLifeCycle } from "hooks";
import Lottie from "lottie-react";
import { useAppDispatch } from "stores";
import { systemSlice } from "stores/System";
import i18n from "translations/i18n";
import { loadLocalStorage, saveLocalStorage, saveSessionStorage } from "utils";

/**
 * Do things that is required for the app iniatilly.
 * e.g. take token, fetch user info, etc.
 */
export const AppInitializer = () => {
  const [loadedWholeApp, setLoadedWholeApp] = useState(false);
  const { isInitializing, initUserSession } = useAuth();
  const dispatch = useAppDispatch();

  useDidMountWithoutLifeCycle(() => {
    saveSessionStorage("AppCode", ApplicationCode);
    if (
      !loadLocalStorage("lan") ||
      (loadLocalStorage("lan") &&
        !Object.values(LanguageID)?.includes(
          loadLocalStorage("lan") as LanguageID
        ))
    ) {
      saveLocalStorage("lan", LanguageID.vi);
      dispatch(systemSlice.actions.changeLanguage(LanguageID.vi));
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      dispatch(
        systemSlice.actions.changeLanguage(loadLocalStorage("lan") as never)
      );
    }
    initUserSession();
  });

  useEffect(() => {
    const onPageLoad = () => setLoadedWholeApp(true);

    if (document.readyState === "complete") {
      onPageLoad();
    } else {
      window.addEventListener("load", onPageLoad);
    }

    return () => {
      window.removeEventListener("load", onPageLoad);
    };
  }, []);

  useEffect(() => {
    const handleOffline = () => {
      message({
        title: i18n.t("oopsSomethingWentWrong"),
        content: i18n.t("pleaseCheckYourInternetConnectionAndTryAgain"),
        type: "Warning",
        buttonLabel: "OK",
      });
    };

    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return loadedWholeApp && !isInitializing ? null : (
    <Lottie
      animationData={loadingWholeAppLottie}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        zIndex: 999999,
        backgroundColor: "#fff",
      }}
    />
  );
};
